var _defs, _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsappGreen = function SvgWhatsappGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 11.946 12"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".whatsAppGreen{fill:#40c351;}.whatsAppGreen_b{fill:#20b038;}.whatsAppGreen_c{fill:none;opacity:0.08;}.whatsAppGreen_d,.whatsAppGreen_e{fill:#fff;}.whatsAppGreen_d{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsAppGreen",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20b038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60d66a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "whatsAppGreen",
    d: "M10.206,1.744A5.949,5.949,0,0,0,.844,8.919L0,12l3.153-.827A5.944,5.944,0,0,0,6,11.9H6A5.949,5.949,0,0,0,10.206,1.744ZM6,10.893H6A4.938,4.938,0,0,1,3.48,10.2L3.3,10.1l-1.871.491.5-1.824L1.81,8.577A4.944,4.944,0,1,1,6,10.893Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "whatsAppGreen_b",
    d: "M27.875,32.534l.805-2.941A5.677,5.677,0,1,1,33.6,32.435h0a5.675,5.675,0,0,1-2.712-.691l-3.009.789Z",
    transform: "translate(-27.602 -20.876)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "whatsAppGreen_c",
    width: 6.681,
    height: 6.26,
    transform: "translate(2.655 2.854)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "whatsAppGreen_d",
    d: "M308.807,323.285c-.11-.245-.226-.25-.331-.254-.086,0-.184,0-.282,0a.54.54,0,0,0-.392.184,1.647,1.647,0,0,0-.514,1.225,2.858,2.858,0,0,0,.6,1.519,6.031,6.031,0,0,0,2.51,2.218c1.241.489,1.494.392,1.763.368a1.484,1.484,0,0,0,.992-.7,1.227,1.227,0,0,0,.086-.7c-.037-.061-.135-.1-.282-.171s-.869-.429-1-.478-.233-.073-.331.074-.379.478-.465.576-.171.11-.318.037a4.018,4.018,0,0,1-1.181-.729,4.427,4.427,0,0,1-.817-1.017c-.086-.147-.009-.227.065-.3s.147-.172.22-.257a1.007,1.007,0,0,0,.147-.245.27.27,0,0,0-.012-.257C309.223,324.3,308.938,323.576,308.807,323.285Z",
    transform: "translate(-304.279 -319.863)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "whatsAppGreen_e",
    d: "M17.089,1.838A5.881,5.881,0,0,0,7.834,8.93L7,11.976l3.117-.817a5.876,5.876,0,0,0,2.81.716h0A5.88,5.88,0,0,0,17.089,1.838Zm-4.159,9.044h0A4.881,4.881,0,0,1,10.44,10.2l-.179-.106-1.85.485.494-1.8-.116-.185a4.887,4.887,0,1,1,4.14,2.29Z",
    transform: "translate(-6.931 -0.113)"
  })));
};
export default SvgWhatsappGreen;